import { caseTypeCategory } from 'app/area/case/case-data-model';
import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { ComplexValue, ValueProperty } from 'ui';

export const connectedCasesRiskValues = (caseState, uiEngineProps) => ({
  connectedRiskArea: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskArea').valueItem,  
  connectedRiskWeight: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskWeight').value,
  connectedRiskTrend: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskTrend').valueItems,
  connectedRiskAreaRest: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskAreaRest').valueItem,
  connectedRiskWeightRest: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskWeightRest').value,
  connectedRiskTrendRest: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedRiskTrendRest').valueItems
});

export interface ConnectedCasesRiskValueShape {
  connectedRiskArea: ComplexValue<number>;  
  connectedRiskWeight: ValueProperty;
  connectedRiskTrend: ComplexValue<number>[];
  connectedRiskAreaRest: ComplexValue<number>;
  connectedRiskWeightRest: ValueProperty;
  connectedRiskTrendRest: ComplexValue<number>[];
}


export const connectedCasesBowtieSupported = (caseState, uiEngineProps) => ({
  connectedBowtieSupported: 
    (resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedApplicationCategory').valueItems)[0]?.value === 
      caseTypeCategory.topevent
});

export interface ConnectedCasesBowtieSupportedShape {
  connectedBowtieSupported: boolean;
}
